import {Injectable} from "@angular/core";
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import { Router } from '@angular/router';
import {AuthService} from "./auth.service";


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(public router: Router, public authService: AuthService){}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        if (this.authService.getAuthToken()) {
            return true;
        } else {
            this.router.navigate(['login']);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/authentication/auth.guard.ts